<app-header>
  <bit-breadcrumbs slot="breadcrumbs">
    <bit-breadcrumb route="../" icon="bwi-sliders">
      {{ "reports" | i18n }}
    </bit-breadcrumb>
    @if (vfo1Enabled()) {
      <bit-breadcrumb [route]="[]">
        {{ reportTitleKey | i18n }}
      </bit-breadcrumb>
    }
  </bit-breadcrumbs>
</app-header>

<bit-container>
  <p>
    {{ "passkeyLoginReportDesc" | i18n }}
    <a
      bitLink
      href="https://bitwarden.com/blog/how-do-passkeys-work/"
      target="_blank"
      rel="noreferrer"
    >
      {{ "passkeyLoginReportHowTheyWork" | i18n }}
    </a>
    {{ "passkeyLoginReportAnd" | i18n }}
    <a bitLink href="https://bitwarden.com/help/storing-passkeys/" target="_blank" rel="noreferrer">
      {{ "passkeyLoginReportHowToUse" | i18n }}
    </a>
  </p>
  @if (loading()) {
    <div>
      <bit-icon
        name="bwi-spinner"
        class="bwi-spin tw-text-muted"
        title="{{ 'loading' | i18n }}"
        aria-hidden="true"
      ></bit-icon>
      <span class="tw-sr-only">{{ "loading" | i18n }}</span>
    </div>
  } @else {
    <div class="tw-mt-4">
      @if (error()) {
        <bit-callout type="danger">
          {{ "reportError" | i18n }}
        </bit-callout>
      } @else if (!ciphers().length) {
        <bit-callout type="success" title="{{ 'goodNews' | i18n }}">
          {{ "noPasskeyLogin" | i18n }}
        </bit-callout>
      } @else {
        <bit-callout type="info" title="{{ 'passkeyLoginFound' | i18n }}">
          {{ "passkeyLoginFoundInfoPrefix" | i18n }}
          <strong class="tw-font-semibold">{{
            "loginsCount" | i18n: (ciphers().length | number)
          }}</strong>
          {{ infoBannerSuffixKey() | i18n }}
        </bit-callout>
        @if (showFilterToggle()) {
          @if (canDisplayToggleGroup()) {
            <bit-toggle-group
              [selected]="currentFilterStatus()"
              (selectedChange)="filterOrgToggle($event ?? 0)"
              [attr.aria-label]="'addAccessFilter' | i18n"
            >
              @for (status of filterStatus(); track status) {
                <bit-toggle [value]="status">
                  {{ getName(status) }}
                  <bit-berry [value]="getCount(status)" />
                </bit-toggle>
              }
            </bit-toggle-group>
          } @else {
            <bit-chip-filter
              [placeholderText]="chipSelectOptions()[0].label"
              [options]="chipSelectOptions()"
              [ngModel]="selectedFilterChip"
              (ngModelChange)="filterOrgToggleChipSelect($event)"
              fullWidth="true"
            ></bit-chip-filter>
          }
        }
        <bit-table-scroll [dataSource]="dataSource" [rowSize]="75" layout="fixed">
          <ng-container header>
            <th bitCell class="tw-w-5/12">{{ "name" | i18n }}</th>
            <th bitCell class="tw-w-3/12">{{ "vault" | i18n }}</th>
            <th bitCell class="tw-w-1/6">{{ "type" | i18n }}</th>
            <th bitCell class="tw-w-1/6 tw-text-right">{{ "options" | i18n }}</th>
          </ng-container>
          <ng-template bitRowDef let-row>
            <td bitCell>
              <div class="tw-flex tw-items-center tw-gap-4">
                <app-vault-icon [cipher]="row.cipher"></app-vault-icon>
                <span class="tw-truncate tw-min-w-0">
                  <a
                    bitLink
                    href="#"
                    appStopClick
                    (click)="selectCipher(row.cipher)"
                    title="{{ 'editItemWithName' | i18n: row.cipher.name }}"
                    >{{ row.cipher.name }}</a
                  >
                  @if (row.cipher.organizationId) {
                    <bit-icon
                      [name]="'bwi-collection-shared' | vfo1Icon"
                      class="tw-ml-1"
                      appStopProp
                      title="{{ 'shared' | i18n }}"
                      aria-hidden="true"
                    ></bit-icon>
                    <span class="tw-sr-only">{{ "shared" | i18n }}</span>
                  }
                  @if (row.cipher.hasAttachments) {
                    <bit-icon
                      name="bwi-paperclip"
                      class="tw-ml-1"
                      appStopProp
                      title="{{ 'attachments' | i18n }}"
                      aria-hidden="true"
                    ></bit-icon>
                    <span class="tw-sr-only">{{ "attachments" | i18n }}</span>
                  }
                  <br />
                  <small>{{ row.cipher.subTitle }}</small>
                </span>
              </div>
            </td>
            <td bitCell class="tw-truncate">
              @if (row.cipher.organizationId) {
                @let orgName = row.cipher.organizationId | orgNameFromId: organizations() ?? [];
                {{ "orgNameVault" | i18n: orgName ?? "" }}
              } @else {
                {{ "myVault" | i18n }}
              }
            </td>
            <td bitCell>
              <div class="tw-flex tw-gap-2 tw-items-center">
                @if (row.supportsPasskeyLogin) {
                  <span bitBadge size="small" variant="subtle">
                    {{ "login" | i18n }}
                  </span>
                }
                @if (row.supportsPasskeyMfa) {
                  <span bitBadge size="small" variant="subtle">2FA</span>
                }
              </div>
            </td>
            <td bitCell>
              @if (row.instructions) {
                <a
                  bitButton
                  endIcon="bwi-external-link"
                  [href]="row.instructions"
                  target="_blank"
                  rel="noreferrer"
                >
                  {{ "instructions" | i18n }}
                </a>
              }
            </td>
          </ng-template>
        </bit-table-scroll>
      }
    </div>
  }
</bit-container>
